var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetDrugInteractionLevelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6202 6.1506V0H13.9402V6.1506C12.977 6.31312 12.2402 7.15088 12.2402 8.16C12.2402 9.16912 12.977 10.0065 13.9402 10.1694V16.32H14.6202V10.1694C15.5835 10.0069 16.3202 9.16912 16.3202 8.16C16.3202 7.15088 15.5835 6.31346 14.6202 6.1506ZM14.2802 9.52C13.5302 9.52 12.9202 8.91004 12.9202 8.16C12.9202 7.40996 13.5302 6.8 14.2802 6.8C15.0303 6.8 15.6402 7.40996 15.6402 8.16C15.6402 8.91004 15.0303 9.52 14.2802 9.52Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.7 0V2.4106C0.73678 2.57346 0 3.41122 0 4.42C0 5.42878 0.73678 6.26654 1.7 6.4294V16.32H2.38V6.4294C3.34322 6.26688 4.08 5.42912 4.08 4.42C4.08 3.41088 3.34322 2.57346 2.38 2.4106V0H1.7ZM3.4 4.42C3.4 5.17004 2.79004 5.78 2.04 5.78C1.28996 5.78 0.68 5.17004 0.68 4.42C0.68 3.66996 1.28996 3.06 2.04 3.06C2.79004 3.06 3.4 3.66996 3.4 4.42Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82012 0V10.2306C6.8569 10.3931 6.12012 11.2309 6.12012 12.24C6.12012 13.2491 6.8569 14.0865 7.82012 14.2494V16.32H8.50012V14.2494C9.46334 14.0869 10.2001 13.2491 10.2001 12.24C10.2001 11.2309 9.46334 10.3935 8.50012 10.2306V0H7.82012ZM9.52012 12.24C9.52012 12.99 8.91016 13.6 8.16012 13.6C7.41008 13.6 6.80012 12.99 6.80012 12.24C6.80012 11.49 7.41008 10.88 8.16012 10.88C8.91016 10.88 9.52012 11.49 9.52012 12.24Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetDrugInteractionLevelIcon);
export default __webpack_public_path__ + "static/media/SetDrugInteractionLevelIcon.0ed4b54b827dab181a83d89ea19551b0.svg";
export { ForwardRef as ReactComponent };